<!-- Application Layout -->
<app-header></app-header>
<div class="content--container">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>


<div id="warningModal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog"
    aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header -nobg">
                <div class="float-left">
                    <h4 class="modal-title"><span class="text">คำเตือน</span></h4>
                </div>
                <div class="float-right">
                    <button type="button" id="closeNotice" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="userDisagree()">
                        <span aria-hidden="true"><i class="icon-close custom-color-icon"></i></span>
                    </button>
                </div>
            </div>
            <section class="wrapper-notice">
                <div class="modal-body" tabindex="4">
                    <ol class="list">
                        <li>การลงทุนในหน่วยลงทุนมิได้เป็นการฝากเงิน และมีความเสี่ยงจากการลงทุน
                            ผู้ถือหน่วยลงทุนอาจได้รับเงินลงทุนคืนมากกว่าหรือน้อยกว่าเงินลงทุนเริ่มแรก
                            รวมถึงอาจไม่ได้รับชำระเงินค่าขายคืนหน่วยลงทุนภายในเวลาที่กำหนด
                            หรืออาจไม่สามารถขายคืนหน่วยลงทุนตามที่ได้มีคำสั่งไว้
                        </li>
                        <li>การวัดผลการดำเนินงาน ของกองทุนบนเว็บไซต์นี้ ได้จัดทำขึ้นตามมาตรฐาน การวัดผลการดำเนินงาน
                            ของกองทุนรวมของสมาคมบริษัทจัดการลงทุน
                            โดยผลการดำเนินงานในอดีตของกองทุนมิได้เป็นสิ่งยืนยันถึงผลการดำเนินงานในอนาคต
                        </li>
                        <li>การลงทุนมีความเสี่ยง ผู้ลงทุนควรศึกษาข้อมูลในหนังสือชี้ชวนการเสนอขายกองทุน และคู่มือภาษี
                            กรณีลงทุนในกองทุนรวมเพื่อการเลี้ยงชีพและ/หรือกองทุนรวมหุ้นระยะยาว
                            ให้ถี่ถ้วนเพื่อใช้ประกอบการตัดสินใจซื้อหน่วยลงทุน และเก็บไว้เป็นข้อมูล
                            เพื่อใช้อ้างอิงในอนาคต
                            ทั้งนี้ สำหรับผู้ที่ต้องการทราบข้อมูล หรือรายละเอียดเพิ่มเติม นอกเหนือจากที่ปรากฏใน เว็บไซต์
                            นี้ สามารถตรวจสอบหรือขอสำเนาหนังสือชี้ชวน ส่วนข้อมูลโครงการ ได้ที่ บลจ.วรรณ
                            หรือตัวแทนสนับสนุนการขายและรับซื้อคืนที่บริษัทจัดการแต่งตั้ง
                        </li>
                        <li>การที่สำนักงานคณะกรรมการ ก.ล.ต. ได้อนุมัติให้จัดตั้งและจัดการกองทุนรวมที่ปรากฎอยู่ใน
                            เว็บไซต์ นี้ มิได้ แสดงว่า คณะกรรมการ ก.ล.ต. และสำนักงานคณะกรรมการ ก.ล.ต.
                            ได้รับรองถึงความถูกต้องของข้อมูลในหนังสือชี้ชวน และ มิได้ประกันราคาหน่วยลงทุนที่เสนอขาย
                        </li>
                        <li>กองทุนรวมเป็นนิติบุคคลแยกต่างหากจากบริษัทจัดการ ดังนั้น
                            บริษัทจัดการจึงไม่มีภาระผูกพันในการชดเชยผลขาดทุนของกองทุนรวม
                            และผลการดำเนินงานของกองทุนไม่ได้ขึ้นอยู่กับสถานะทางการเงินหรือผลการดำเนินงานของบริษัทจัดการ
                        </li>
                        <li>ผู้ลงทุนสามารถตรวจดูข้อมูลที่อาจมีผลต่อการตัดสินใจลงทุน เช่น
                            การทำธุรกรรมกับบุคคลที่เกี่ยวข้อง (Connected person)
                            และการลงทุนตามอัตราส่วนที่กำหนดในวัตถุประสงค์การลงทุน ได้ที่สำนักงานคณะกรรมการ ก.ล.ต.
                            หรือโดยผ่านเครือข่าย Internet
                            ของสำนักงานคณะกรรมการ ก.ล.ต.(<a href="http://www.sec.or.th"
                                class="link-orange">www.sec.or.th</a>)</li>
                        <li>ข้อมูลที่ปรากฎอยู่ใน เว็บไซต์นี้บริษัทจัดการ ได้จัดทำและรวบรวมขึ้นด้วยความสุจริต
                            และพยายามจัดทำขึ้น บนพื้นฐานของแหล่งข้อมูลที่มีความน่าเชื่อถือ เพื่อให้เป็นข้อมูลที่ถูกต้อง
                            อย่างไรก็ดี บริษัทจัดการและผู้บริหาร รวมถึงพนักงานเจ้าหน้าที่
                            ของบริษัทมิอาจรับประกันความถูกต้อง ครบถ้วน หรือความน่าเชื่อถือของข้อมูลดังกล่าวได้ ทั้งนี้
                            อาจมีสาเหตุมาจาก ข้อมูลนั้นเอง หรืออาจมาจากสาเหตุอื่น ๆ ดังนั้น
                            หากผู้ลงทุนจะใช้ข้อมูลที่ปรากฏอยู่ในเว็บไซต์นี้ เพื่อการดำเนินการอย่างใดอย่างหนึ่ง
                            ผู้ลงทุนควรใช้ด้วยความรอบคอบ หรือใช้ข้อมูลจากแหล่งอื่นๆ ประกอบการพิจารณาด้วย</li>
                        <li>บริษัทจัดการอาจลงทุนในหลักทรัพย์ หรือ ทรัพย์สินอื่น เพื่อบริษัทจัดการ เช่นเดียวกับที่
                            บริษัทจัดการลงทุนในหลักทรัพย ์หรือ ทรัพย์สินอื่นเพื่อกองทุนตามหลักเกณฑ์
                            ที่สำนักงานคณะกรรมการ ก.ล.ต.กำหนด ทั้งนี้
                            หากต้องการทราบข้อมูลการลงทุนเพื่อบริษัทจัดการในรายละเอียด
                            สามารถขอดูข้อมูลได้ที่ บริษัทจัดการ ตัวแทน และสำนักงานคณะกรรมการ ก.ล.ต.</li>
                        <li>บริษัทจัดการอนุญาตให้พนักงานลงทุนในหลักทรัพย์เพื่อตนเองได้ โดยปฏิบัติตามจรรยาบรรณ
                            และประกาศต่างๆ ที่เกี่ยวข้องกับการลงทุนที่สำนักงานคณะกรรมการกำกับหลักทรัพย์และตลาดหลักทรัพย์
                            (ก.ล.ต.) และหน่วยงานที่เกี่ยวข้องประกาศกำหนด
                        </li>
                        <li>บริษัทจัดการและผู้บริหาร รวมถึงพนักงานเจ้าหน้าที่ของบริษัท ขอสงวนสิทธิ์ที่จะไม่รับผิดชอบ
                            ต่อความเสียหายทุกกรณี ที่เกิดขึ้นกับข้อมูล หรือ ระบบสื่อสารของผู้เข้าเยี่ยมชมหรือผู้ลงทุน
                            อันเนื่องมาจากการเข้ามาใช้เว็บไซต์นี้ และหรือ เว็บไซต์ที่ร่วมกิจกรรมกับบริษัท</li>
                        <li>บริษัทจัดการขอสงวนสิทธิ์ในการแก้ไข ปรับปรุง หรือเปลี่ยนแปลงข้อมูลใดๆใน เว็บไซต์
                            นี้ได้โดยไม่จำต้องแจ้งให้ทราบล่วงหน้าแต่อย่างใด บริษัทจัดการขอสงวนสิทธิ์ในการเผยแพร่ อ้างอิง
                            ลอกเลียน ทำซ้ำ หรือแก้ไข ด้วยวิธีการใด ๆ ไม่ว่าทั้งหมด
                            หรือบางส่วน ของข้อมูลในเว็บไซต์ของบริษัท เว้นแต่จะได้รับอนุญาตจากบริษัทเป็นลายลักษณ์อักษร
                            การแก้ไข เปลี่ยนแปลง รายงาน ข้อความ ข้อมูล เอกสาร หรือ สื่อใดๆ ในเว็บไซต์นี้ด้วยวิธีการใดๆ
                            โดยเจตนา หรือ โดยมิได้รับอนุญาตจากบริษัทก่อน
                            และเป็นผลให้เกิดความเสียหายต่อทรัพย์สิน หรือ ชื่อเสียงของบริษัท หรือ บุคคลอื่น
                            เป็นการกระทำที่ผิดกฎหมาย ซึ่งผู้กระทำดังกล่าวนอกจากจะต้องรับผิดชอบต่อความเสียหาย
                            ในทางแพ่งแล้ว อาจต้องรับโทษ ในทางอาญาด้วย</li>
                        <li>เว็บไซต์ต่าง ๆ ทั้งในและต่างประเทศที่ Links อยู่ในเว็บไซต์นี้
                            บริษัทจัดการได้รวบรวมขึ้นเพื่อความสะดวกในการเข้าไปเผยแพร่ข้อมูลเท่านั้น
                            ดังนั้นการที่เว็บไซต์ดังกล่าวเสนอข้อมูล ความรู้ แนวคิด หรือเสนอการให้บริการ
                            หรือการเสนอขายสินค้าต่างๆ
                            ที่มีอยู่ในเว็บไซต์ดังกล่าวต่อผู้ที่สนใจเข้าชมเว็บไซต์นั้น
                            โดยเฉพาะเว็บไซต์ต่างประเทศบางแห่งในปัจจุบันอาจจะยังไม่สามารถให้บริการ หรือเสนอขายสินค้าต่างๆ
                            ในประเทศไทยได้
                            ผู้เข้าชมหรือรับบริการหรือซื้อสินค้าจากเว็บไซต์ดังกล่าวควรต้องศึกษาและตรวจสอบข้อมูล
                            โดยละเอียดก่อนตัดสินใจรับบริการ ซื้อสินค้า หรือดำเนินการใดๆ
                            บริษัทจัดการไม่เกี่ยวข้องกับข้อมูลหรือการเสนอให้บริการ หรือการเสนอขายสินค้าต่างๆ
                            รวมทั้งไม่รับรองความถูกต้องของข้อมูลหรือการเสนอให้บริการ
                            หรือการเสนอขายสินค้าที่มีอยู่ในเว็บไซต์นั้น</li>
                    </ol>
                </div>
            </section>
            <div class="modal-footer" style="margin: 0 auto">
                <app-button text="{{language.btn1}}" outline="true" size="lg" (click)="userDisagree()"></app-button>
                <app-button text="{{language.btn2}}" size="lg" (click)="userAgree()"></app-button>
            </div>
        </div>
    </div>
</div>

<div id="onelivetopineModal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog"
    aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
            <br>
            <!-- <div class="modal-header -nobg" style="height: 50px;">
                <div class="float-left">
                    <h5 class="modal-title"><span class="text">{{language.fundopenaccountpineheader}}</span></h5>
                </div>
                <div class="float-right">
                    <button type="button" id="closeNotice" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="notgotopine()" style="height: 33px; width: 33px;">
                        <span aria-hidden="true"><i class="icon-close custom-color-icon"></i></span>
                    </button>
                </div>
            </div> -->
            <section class="wrapper-notice">
                <div class="modal-body" style="overflow: visible;">
                    {{language.fundopenaccountpinemodal}}
                </div>
            </section>
            <div class="modal-footer" style="margin: 0 auto">
                <app-button text="{{language.btn1}}" outline="true" size="md" (click)="notgotopine()"></app-button>
                <app-button text="{{language.btn2}}" size="md" (click)="gotopine()"></app-button>
            </div>
        </div>
    </div>
</div>

<div id="alertModal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog"
    aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header -nobg">
                <div class="float-left">
                    <h4 class="modal-title"><span class="text">แจ้งเตือน</span></h4>
                </div>
                <div class="float-right">
                    <button type="button" id="closeNotice" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="userDisagree()">
                        <span aria-hidden="true"><i class="icon-close custom-color-icon"></i></span>
                    </button>
                </div>
            </div>
            <section class="wrapper-notice">
                <div class="modal-body">
                    <br><br> ทางเว็บไซต์ One Asset จะทำการเก็บข้อมูล Cookie ในการเข้าระบบทุกครั้ง <br><br>
                    เพื่อใช้ในการนำเสนอข้อมูลและบริการให้ตรงตามความต้องการของผู้ใช้งานต่อไป <br><br>
                </div>
            </section>

            <div class="modal-footer" style="margin: 0 auto">
                <app-button text="{{language.btn2}}" size="lg" (click)="userAgreeAlert()"></app-button>
            </div>

        </div>
    </div>
</div>

<div id="warningModalForformanceSum" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog"
    aria-labelledby="myLargeModalLabel" aria-hidden="false">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header -nobg">
                <div class="float-left">
                    <h4 class="modal-title"><span class="text">คำเตือน</span></h4>
                </div>
                <div class="float-right">
                    <button type="button" id="closeNotice" class="close" data-dismiss="modal" aria-label="Close"(click)="userclosesum()">
                        <span aria-hidden="true"><i class="icon-close custom-color-icon"></i></span>
                    </button>
                </div>
            </div>
            <section class="wrapper-notice">
                <div class="modal-body" tabindex="4" style="line-height: 1.6; text-align: center;">
                    <h4>ไม่พบข้อมูล</h4>
                </div>
            </section>
            <div class="modal-footer" style="margin: 0 auto">
                <app-button id="btntest" text="{{language.ed_pop_up}}" size="lg"  data-dismiss="modal" (click)="userclosesum()"></app-button>
            </div>
        </div>
    </div>
</div>

<div id="popupModal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog"
    aria-labelledby="myLargeModalLabel" aria-hidden="false">
    <div class="modal-dialog modal-lg modal-dialog-centered"> 
        <div class="modal-content">
            <span class="close-popup text-right" (click)="closePopup()">&times;</span>
            <img src="{{popupImage}}" alt="popup" (click)="linkPopup()" />
            <!-- check box display once -->
            <!-- <br/>
            <label class="checkbox-inline  icheck-label icheck[8z79b] needsclick">
              <app-checkbox name="donotshow" [checked]="isNotPopup" [checkboxValue]="1" (returnCheckboxValue)="alert($event)"></app-checkbox>
              ไม่แสดงหน้านี้อีก
            </label> -->
        </div>
    </div>
</div>